import { render, staticRenderFns } from "./IssueSolveTimeModal.vue?vue&type=template&id=5c55c614&scoped=true"
import script from "./IssueSolveTimeModal.vue?vue&type=script&lang=js"
export * from "./IssueSolveTimeModal.vue?vue&type=script&lang=js"
import style0 from "./IssueSolveTimeModal.vue?vue&type=style&index=0&id=5c55c614&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c55c614",
  null
  
)

export default component.exports